<template>
    <div>
        <!--<registration-bonus-banner v-if="registrationBanner"
        :currency="currency" />-->

        <p class="title title-step">{{ 'components.pages.registration.step1' | translate }}</p>

        <form @submit.prevent="submit()" :class="{ 'is-loading': loading }" role="form">
            <!-- Email input-->
            <div class="field field-block has-addons">
                <div class="control has-icons-left is-expanded">
                    <input
                        v-model.trim="email"
                        v-validate="'required|email|unique-login|min:5|max:50'"
                        data-vv-name="email"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.email' | translate"
                        class="input is-large"
                        type="text"
                        autofocus="on"
                        maxlength="50"
                    />
                    <span class="icon is-small is-left"><i class="far fa-envelope"></i></span>
                </div>
                <p class="help is-danger" v-if="errors.has('email:required')">
                    {{ 'components.pages.registration.validation.email required' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('email:min')">
                    {{ 'components.pages.registration.validation.email min length' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('email:max')">
                    {{ 'components.pages.registration.validation.email max length' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('email:unique-login')">
                    {{ 'components.pages.registration.validation.email in use' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('email:email')">
                    {{ 'components.pages.registration.validation.email format' | translate }}
                </p>
            </div>
            <template v-if="isLiveBetLine">
                <div class="field">
                    <div class="control has-icons-left has-icons-right">
                        <input
                            v-model.trim="firstName"
                            v-validate="{ required: true }"
                            data-vv-name="firstName"
                            data-vv-validate-on="input"
                            :placeholder="'components.pages.profile.settings.first name' | translate"
                            class="input is-large"
                            type="text"
                            maxlength="50"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                    </div>
                    <p v-if="errors.has('firstName:required')" class="help is-danger">
                        {{ 'components.pages.profile.validation.field required' | translate }}
                    </p>
                </div>
                <div class="field">
                    <div class="control has-icons-left has-icons-right">
                        <input
                            v-model.trim="lastName"
                            v-validate="{ required: true }"
                            data-vv-name="lastName"
                            data-vv-validate-on="input"
                            :placeholder="'components.pages.profile.settings.last name' | translate"
                            class="input is-large"
                            type="text"
                            maxlength="50"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                    </div>
                    <p v-if="errors.has('lastName:required')" class="help is-danger">
                        {{ 'components.pages.profile.validation.field required' | translate }}
                    </p>
                </div>
                <div class="field">
                    <div class="control has-icons-left has-icons-right">
                        <input
                            v-validate="{ required: true }"
                            data-vv-name="dateOfBirth"
                            data-vv-validate-on="input"
                            ref="dateOfBirth"
                            class="input is-large"
                            type="text"
                            readonly
                            :placeholder="'components.pages.profile.settings.date of birth' | translate"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-calendar"></i></span>
                    </div>
                    <p v-if="errors.has('dateOfBirth:required')" class="help is-danger">
                        {{ 'components.pages.profile.validation.field required' | translate }}
                    </p>
                </div>
            </template>
            <!-- Password input-->
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input
                        v-model.trim="password"
                        v-validate="{ required: true, min: 4, max: 20, regex: /^[^\s]+$/ }"
                        data-vv-name="password"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.password' | translate"
                        class="input is-large"
                        :type="showPassword ? 'text' : 'password'"
                        maxlength="20"
                        ref="password"
                    />
                    <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
                    <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                        <span v-show="!showPassword"><i class="far fa-eye-slash"></i></span>
                        <span v-show="showPassword"><i class="far fa-eye"></i></span>
                    </a>
                </div>
                <p class="help is-danger" v-if="errors.has('password:required')">
                    {{ 'components.pages.registration.validation.password required' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('password:min')">
                    {{ 'components.pages.registration.validation.password min length' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('password:max')">
                    {{ 'components.pages.registration.validation.password max length' | translate }}
                </p>
            </div>
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input
                        v-model.trim="confirmedPassword"
                        v-validate="{ required: true, is: password }"
                        data-vv-name="confirmedPassword"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.repeat password' | translate"
                        class="input is-large"
                        :type="showPassword ? 'text' : 'password'"
                        maxlength="20"
                        ref="confirmedPassword"
                    />
                    <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
                    <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                        <span v-show="!showPassword"><i class="far fa-eye-slash"></i></span>
                        <span v-show="showPassword"><i class="far fa-eye"></i></span>
                    </a>
                </div>
                <p class="help is-danger" v-if="errors.has('confirmedPassword:required')">
                    {{ 'components.pages.registration.validation.password required' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('confirmedPassword:is')">
                    {{ 'components.pages.login.validation.confirmed' | translate }}
                </p>
            </div>
            <!-- Alias input-->
            <div v-if="askAliasDuringRegistration" class="field">
                <div class="control has-icons-left">
                    <input
                        v-model.trim="alias"
                        v-validate="'min:3|max:50'"
                        data-vv-name="alias"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.alias' | translate"
                        class="input is-large"
                        typeof="text"
                        maxlength="50"
                    />
                    <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                </div>
                <p class="help is-danger" v-if="errors.has('alias:min')">
                    {{ 'components.pages.registration.validation.alias min length' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('alias:max')">
                    {{ 'components.pages.registration.validation.alias max length' | translate }}
                </p>
            </div>
            <!-- Currency input-->
            <div v-if="visibleCurrencies && visibleCurrencies.length > 1" class="field bng-center-field">
                <div class="control has-icons-left">
                    <div class="select is-large">
                        <select v-model="currency" v-validate="'required'" data-vv-name="currency" data-vv-validate-on="change">
                            <option :value="null">
                                {{ 'components.pages.registration.choose currency' | translate }}
                            </option>
                            <option v-for="(c, index) of visibleCurrencies" :key="index" :value="c.id">
                                {{ c.description }} ({{ c.id }})
                            </option>
                        </select>
                    </div>
                    <span class="icon is-left"><i class="fas fa-money-bill-alt"></i></span>
                    <p class="help is-danger" v-if="errors.has('currency:required')">
                        {{ 'components.pages.registration.validation.currency required' | translate }}
                    </p>
                </div>
            </div>
            <!-- Agreement input-->
            <div class="field bng-center-field">
                <div class="control">
                    <label class="checkbox">
                        <input
                            v-model="agreement"
                            v-validate="'required'"
                            data-vv-name="agreement"
                            data-vv-validate-on="change"
                            type="checkbox"
                        />
                        <span>{{ 'components.pages.registration.agreement' | translate }}</span>
                        <router-link target="_blank" :to="{ name: 'rules-inner', params: { rule: mainRulesRef && mainRulesRef.name } }">{{
                            'components.pages.registration.agreement rules' | translate
                        }}</router-link>
                    </label>
                    <p class="help is-danger" v-if="errors.has('agreement:required')">
                        {{ 'components.pages.registration.validation.agreement required' | translate }}
                    </p>
                </div>
            </div>
            <!-- Recaptcha-->
            <recaptcha v-if="false" :on-response="response => (data.recaptchaResponse = response)" ref="recaptcha" />

            <button class="card-footer-item button is-large is-link" :class="{ 'is-loading': loading }" type="submit">
                <span>{{ 'components.pages.registration.continue' | translate }}</span>
                <span class="icon is-small"><i class="fas fa-arrow-right"></i></span>
            </button>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';
import flatpickr from 'flatpickr';
import moment from 'moment-timezone';

import { mapGetters } from 'vuex';

import registrationService from '../../../../../../_common/services/registration.service';
import rulesHelper from '../../../../../../_common/helpers/rules.helper';
import currencyHelper from '../../../../../../_common/helpers/currency.helper';

import UniqueLoginValidationRule from '../../../../../../_common/mixins/unique-login.validation-rule.mixin';

import Recaptcha from '../../../common/recaptcha/recaptcha.vue';
//import RegistrationBonusBanner from "../banners/registration-bonus";

export default {
    name: 'registration-by-email',
    $_veeValidate: { validator: 'new' },
    props: {
        toStep2: {
            type: Function,
            required: true
        },
        branchCode: {
            type: String
        }
    },
    components: { Recaptcha }, //, RegistrationBonusBanner
    mixins: [UniqueLoginValidationRule],
    data: () => ({
        email: null,

        firstName: null,
        lastName: null,
        dateOfBirth: null,
        calendar: null,

        password: null,
        confirmedPassword: null,
        alias: null,
        currency: null,
        agreement: false,
        type: 'email',
        recaptchaResponse: null,
        showPassword: false,
        loading: false,
        mainRulesRef: null,
        visibleCurrencies: null
    }),
    computed: {
        ...mapGetters(['client']),
        askAliasDuringRegistration() {
            return this.client && this.client.view.auth.askAliasDuringRegistration;
        },
        registrationBonus() {
            let client = Vue.state.client.get();
            return client && client.bonus && client.bonus.registration;
        },
        registrationBanner() {
            return (
                this.client &&
                this.client.view.banners.registrationBanner &&
                this.registrationBonus &&
                this.registrationBonus.registrationTypes.indexOf('email') >= 0
            );
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        clientAlias() {
            return this.client && this.client.view && this.client.view.general && this.client.view.general.alias;
        },
        isLiveBetLine() {
            return this.clientAlias === 'LiveBetLine';
        }
    },
    async created() {
        this.visibleCurrencies = await currencyHelper.getVisibleCurrencies();
        if (this.visibleCurrencies && this.visibleCurrencies.length) {
            this.currency = this.visibleCurrencies[0].id;
        }

        this.mainRulesRef = await rulesHelper.getMainRulesRef(this.lang);
    },
    mounted() {
        if (this.isLiveBetLine) {
            let calendarOptions = {
                enableTime: false,
                time_24hr: true,
                maxDate: moment()
                    .subtract(18, 'years')
                    .toDate(),
                disableMobile: 'true',
                onOpen: function(selectedDates, dateStr, instance) {
                    setTimeout(function() {
                        instance.open();
                    }, 200);
                }
            };

            this.calendar = flatpickr(this.$refs.dateOfBirth, calendarOptions);
        }
    },
    methods: {
        toggleShowPassword(ref) {
            this.showPassword = !this.showPassword;
            setTimeout(() => this.$refs[ref].focus());
        },
        async submit() {
            await this.$validator.validateAll();
            if (this.errors.any() || this.loading) return;

            this.errors.clear();
            this.loading = true;
            let model = {
                email: this.email,
                password: this.password,
                alias: this.alias,
                currency: this.currency,
                recaptchaResponse: this.recaptchaResponse,
                language: Vue.state.lang.currentLang,
                branchCode: this.branchCode
            };

            if (this.isLiveBetLine) {
                model.firstName = this.firstName;
                model.lastName = this.lastName;

                let selectedDate = this.calendar.selectedDates[0];
                model.dateOfBirth = moment(selectedDate).toISOString();
            }

            const result = await registrationService.registerByEmail(model);
            if (result.errorData) {
                result.errorData.forEach(error => {
                    const localize = () => this.$t(`components.pages.registration.errors.${error.key}.${error.message}`, error.extraParams);
                    this.errors.add({
                        field: error.key,
                        msg: localize(),
                        regenerate: localize
                    });
                });
            } else {
                this.toStep2({ email: result.email });
            }

            this.loading = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/registration/by-email.vue